import { IconType } from 'react-icons';
import MenuMobileItem from '@components/ui/MenuMobileItem/MenuMobileItem';
import './MenuMobile.scss';

type MenuMobileItemType = {
    label: string,
    icon: IconType,
    to: string,
    active?: boolean,
    disabled?: boolean,
};

type MenuMobileProps = {
    items: Array<MenuMobileItemType>,
};

function MenuMobile(props: MenuMobileProps) {

    return (
        <nav className="menu-mobile">
            {props.items.map((item: MenuMobileItemType, index: number) => (
                <MenuMobileItem key={index} label={item.label} icon={item.icon} to={item.to} active={item.active} disabled={item.disabled}/>
            ))}
        </nav>
    );
}

export default MenuMobile;
